module.exports = __webpack_public_path__ + "static/img/t3.f4d2207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/draw/t3.png
// module id = gMBM
// module chunks = 1